// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';

export const BtnHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const BoxHolder = styled.div`
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  align-items: flex-start;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px;
`;

export const Title = styled.strong`
  display: block;
  margin: 0;
`;

export const Text = styled.span`
  display: block;
`;

export const TextBox = styled.div`
  flex-grow: 1;
  padding-right: 10px;
`;

export const SubTitle = styled.strong`
  display: block;
  margin: 10px 0 0 0;
`;
